export default __webpack_public_path__ + "static/media/la-brands-400.6ecea482.ttf";